import React from 'react';
import {
  CheckSquare,
  HeartPulse,
  Hourglass,
  RotateCcw,
  ShieldCheck,
} from 'lucide-react';

import PageGuide from '../workspace/PageGuide';

// How Clients works (Nic 2026-10-29): the things a specialist has to know
// about the desk, then the details. The stall rule mirrors
// server/lib/clientMovement.js (signs of life only) and the Onboarding
// Manager's Auto stall setting (14 days by default).
const SECTIONS = [
  {
    tone: 'sky',
    icon: CheckSquare,
    title: 'Your move today is your list',
    text: 'First calls, call-backs, reach-outs, confirm the agreement, review PTRs, a VA.gov nudge, a check-in before Stalled. Doing it clears it; a tick holds it for today.',
  },
  {
    tone: 'amber',
    icon: Hourglass,
    title: 'No sign of life for 14 days stalls them',
    text: 'Last movement counts the days. A meeting ahead holds them.',
    facts: ['14 days'],
  },
  {
    tone: 'rose',
    icon: HeartPulse,
    title: 'What counts is them, not you',
    text: "A reply, an answered call, an upload, a step, their VA.gov. Your texts and unanswered calls still show you reached out; they just don't reset the clock.",
  },
  {
    tone: 'emerald',
    icon: ShieldCheck,
    title: 'Who never stalls',
    text: 'Everything checked off, Ready for CM, and Waiting on PTRs, which gets its own nudge every 14 days instead.',
  },
  {
    tone: 'violet',
    icon: RotateCcw,
    title: "Stalled isn't dead",
    text: 'Re-engage brings them back to work. Mark Dead is the end.',
  },
];

const STEPS = {
  title: 'Where they are',
  items: [
    { name: 'New', value: 'Nothing yet', dot: 'bg-sky-500' },
    {
      name: 'Needs first meeting',
      value: 'Reached, not booked',
      dot: 'bg-sky-500',
    },
    { name: 'Setting up VA.gov', value: 'Their step', dot: 'bg-amber-500' },
    { name: 'Gathering records', value: 'The checklist', dot: 'bg-indigo-500' },
    {
      name: 'Waiting on PTRs',
      value: 'Private records left',
      dot: 'bg-indigo-500',
    },
    { name: 'Ready for CM', value: 'Checklist done', dot: 'bg-emerald-500' },
  ],
};

const NOTES = [
  {
    title: 'Setting up VA.gov',
    text: "Their step, so no to-dos for you until they tap I've done it, except one nudge when they are within 3 days of Stalled.",
  },
  {
    title: 'Your clients are yours',
    text: "Nobody else acts on them, and you don't act on anyone else's. The Onboarding Manager can look at anything and reassign it.",
  },
];

const ClientsGuide = () => (
  <PageGuide title="Clients" sections={SECTIONS} steps={STEPS} notes={NOTES} />
);

export default ClientsGuide;
